import { useBooleanState } from '@cian/react-utils';

import { type FC, useCallback } from 'react';

import { useAdfoxContext } from '@/packages/adfox/AdfoxContext';

import { NativeTGBBannerNarrow } from './internal/components/NativeTGBBannerNarrow';
import { NativeTGBBannerWide } from './internal/components/NativeTGBBannerWide';
import { type NativeTGBBannerProps } from './types';

export const NativeTGBBanner: FC<NativeTGBBannerProps> = props => {
  const { metroIconType, params } = props;
  const { isNarrow } = useAdfoxContext();

  const { state: isClosed, setTrue: setClosedState } = useBooleanState();

  const onClose = useCallback<VoidFunction>(() => {
    setClosedState();
  }, [setClosedState]);

  if (isClosed) {
    return null;
  }

  if (isNarrow) {
    return <NativeTGBBannerNarrow metroIconType={metroIconType} params={params} onClose={onClose} />;
  }

  return <NativeTGBBannerWide metroIconType={metroIconType} params={params} onClose={onClose} />;
};
